<template>
  <v-fade-transition>
    <div
      v-if="show"
      class="h-overlay"
    >
      <div class="h-overlay__scrim"></div>
      <div class="h-overlay__content" :style="position">
        <div
          class="text-right"
          style="height: 32px;"
          :style="`padding-right:${rightPadding}px`"
        >
          <v-icon
            v-if="step == 0 || step == 1"
            :color="color"
            v-text="step == 0 ? icons.viewRooms : icons.viewList"
          />
        </div>
        <v-card
          color="secondary"
          elevation="6"
          width="280"
        >
          <!--
            Do not use the v-card-title component to avoid unexp
            ected text breaking/wrapping.
          -->
          <v-card-text class="text-h5 white--text pb-0" v-text="title" />
          <v-card-text v-if="step == 2" class="pb-0">
            <v-list class="py-0 secondary">
              <v-list-item
                v-for="(n, i) in 5"
                :key="n"
                class="px-0"
              >
                <v-list-item-icon class="mt-0 pt-2 mr-4">
                  <v-avatar
                    :color="tableColors[i]"
                    size="32"
                    class="text-subtitle-1"
                    :class="textColors[i]"
                    rounded
                    v-text="n"
                  />
                </v-list-item-icon>
                <v-list-item-content class="py-0">
                  <v-list-item-title v-text="__(`color${i}Title`)" />
                  <v-list-item-subtitle v-text="__(`color${i}Text`)" />      
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-text v-else-if="step == 3" class="pb-0 text-center">
            <v-btn
              depressed
              color="grey darken-1"
              class="mx-2 text-none"
              :ripple="false"
              v-text="table"
            />
          </v-card-text>
          <v-card-actions :class="step == 2 ? 'mt-2' : 'mt-6'">
            <v-spacer />
            <v-item-group
              v-model="step"
              mandatory
            >
              <v-item
                v-for="n in 4"
                :key="n"
                v-slot="{ active, toggle }"
              >
                <v-btn
                  :input-value="active"
                  icon
                  small
                  :color="active ? 'primary' : 'white'"
                  @click="toggle"
                >
                  <v-icon small v-text="icons.dot" />
                </v-btn>
              </v-item>
            </v-item-group>
            <v-spacer />
          </v-card-actions>

          <v-card-actions v-if="step < 3">
            <v-btn
              v-if="step > 0"
              text
              color="grey"
              @click="step = step - 1"
              v-text="__('previous')"
            />
            <v-spacer />
            <v-btn
              depressed
              color="primary"
              @click="step = step + 1"
              v-text="__('next')"
            />
          </v-card-actions>
          <v-card-actions v-else>
            <v-spacer />
            <v-btn
              depressed
              color="primary"
              @click="close()"
              v-text="__('startNow')"
            />
            <v-spacer />
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </v-fade-transition>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import TableType from '@/Models/Static/TableType'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    data: () => ({
      TableType,
      timer: undefined,
      colorState: false,
      rightPositions: [ 37, 60, 24, 24 ],
      rightDemoPositions: [ 24, 60, 24, 24 ],
      rightPaddings: [ 32, 64, 0, 0 ],
      rightDemoPaddings: [ 8, 28, 0, 0 ],
      tableColors: [
        'grey darken-1',
        'grey lighten-2',
        'warning',
        'info',
        'primary',
      ],
      textColors: [
        'white--text',
        'grey--text text--darken-2',
        'grey--text text--darken-2',
        'grey--text text--darken-2',
        'white--text',
      ],
    }),

    computed: {
      step: {
        get () {
          return this.$store.state.help.quickGuide
        },
        set (v) {
          this.$store.commit('help/quickGuide', v)
        },
      },
      show: {
        get () {
          return this.step !== null
        },
        set (v) {
          this.step = v ? 0 : null
        },
      },
      color () {
        return this.colorState ? 'white' : 'primary'
      },
      rightPadding () {
        return this.$page.props.auth.demo
          ? this.rightDemoPaddings[this.step] ?? 0
          : this.rightPaddings[this.step] ?? 0
      },
      rightPosition () {
        return this.$page.props.auth.demo
          ? this.rightDemoPositions[this.step] ?? 0
          : this.rightPositions[this.step] ?? 0
      },
      position () {
        return `top:14px;right:${this.rightPosition}px;`
      },
      title () {
        return this.__(`quickGuide${this.step}`)
      },
      table () {
        return this.$store.state.rummage.data.TableTable?.find(o => TableType.isTable(o.type_id))?.name ?? 'Table 1'
      },
    },

    created () {
      this.timer = setInterval(() => this.colorState = ! this.colorState, 800)
      if (! localStorage.getItem('firstSteps')) {
        setTimeout(() => this.show = true, 500)
      }
    },

    destroyed () {
      clearInterval(this.timer)
    },

    methods: {
      close () {
        this.$store.commit('help/hide')
        localStorage.setItem('firstSteps', 'done')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .h-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 6;
    width: 100vw;
    height: 100vh;
  }
  .h-overlay__scrim {
    width: 100vw;
    height: 100vh;
    background-color: #212121;
    opacity: .7;
  }
  .h-overlay__content {
    position: absolute;
    transition: right .175s ease-in, top .175s ease-in;
  }
  .v-card {
    transition: width .175s ease;
  }
</style>
